import { MMButton } from '@components/index'
import cn from '@integrations/classnames'
import { useNavigate } from '@integrations/routing'
import { paths } from 'mmfintech-backend-api'
import { tr } from 'mmfintech-commons'
import styles from './AccessDenied.module.scss'

function AccessDenied() {
  const navigate = useNavigate()

  return (
    <div className={cn(styles['access-denied-wrapper'], 'access-denied-wrapper')}>
      <div className={cn(styles['access-denied-container'], 'access-denied-container', 'shadow-raised-frame')}>
        <h1 className={cn(styles['title'], 'title')}>{tr('FRONTEND.ACCESS_DENIED.TITLE', 'Access Denied')}</h1>
        <h2 className={cn(styles['headline'], 'headline')}>
          {tr(
            'FRONTEND.ACCESS_DENIED.DESCRIPTION',
            'Sorry but it seems that you cannot access this area because your account does not have the right to view this page.'
          )}
        </h2>
        <MMButton
          type='button'
          variant='primary'
          caption={tr('FRONTEND.ACCESS_DENIED.BACK_BUTTON', 'Back to overview')}
          onClick={() => navigate(paths.dashboard())}
          className={cn(styles['button-back'], 'button-back')}
          fullWidth
          data-test='button-back'
        />
      </div>
    </div>
  )
}

export default AccessDenied
